import { render } from "./FilteredDogs.vue?vue&type=template&id=2ec016ae"
import script from "./FilteredDogs.vue?vue&type=script&lang=js"
export * from "./FilteredDogs.vue?vue&type=script&lang=js"
script.render = render

export default script